import { emojis } from "./emojis"

export { emojis }

export const STATUSES = {
  on_track: { label: "On Track", class: "on_track" },
  at_risk: { label: "At Risk", class: "at_risk" },
  critical: { label: "Critical", class: "critical" },
  on_hold: { label: "On Hold", class: "on_hold" },
  complete: { label: "Complete", class: "complete" },
  past_due: { label: "Past Due", class: "past_due" },
  not_met: { label: "Not Met", class: "not_met" }
} as const

export const STATUS_NAMES = {
  on_track: "On Track",
  at_risk: "At Risk",
  critical: "Critical",
  on_hold: "On Hold",
  complete: "Complete",
  past_due: "Past Due",
  not_met: "Not Met"
}

/******************************
 * Roles
 ******************************/
export const STANDARD_ROLES = {
  admin: "Plan Admin",
  leader: "Leadership Team",
  manager: "Management Team",
  member: "Team Member",
  recognition: "Recognition Member",
  community: "Community Member"
} as const

export const ALL_ROLES = {
  ...STANDARD_ROLES,
  coach: "Coach"
} as const

export const FREE_ROLES = {
  admin: "Plan Admin",
  leader: "Leadership Team",
  manager: "Management Team"
}

export const FREE_DEPARTMENT_MAX = 4
export const FREE_RECOGNITION_MAX = 3

const COACH = "coach"
const ADMIN = "admin"
const LEADER = "leader"
const MANAGER = "manager"
const MEMBER = "member"
const RECOGNITION = "recognition"
const ALIGNMENT = "alignment"
const COMMUNITY = "community"

export const ROLES_LIST = [
  { id: COACH, label: "Coach" },
  { id: ADMIN, label: "Plan Admin" },
  { id: LEADER, label: "Leadership Team" },
  { id: MANAGER, label: "Management Team" },
  { id: MEMBER, label: "Team Member" },
  { id: RECOGNITION, label: "Recognition Member" },
  { id: ALIGNMENT, label: "Alignment Member" },
  { id: COMMUNITY, label: "Community Member" }
] as const

export const ROLE_RELATIONSHIPS: Record<ProductRoleType, RoleType[]> = {
  full_access: [ADMIN, LEADER, MANAGER],
  team_member: [MEMBER],
  recognition_member: [RECOGNITION]
} as const

export const PRODUCT_ROLES = [
  { id: "full_access", label: "Full Access" },
  { id: "team_member", label: "Team Member" },
  { id: "recognition_member", label: "Recognition Member" }
] as const

type ProductRoleList = {
  role: RoleType
  product_role: ProductRoleType
  label: string
}

export const SUBSCRIPTION_ROLES_LIST = [
  { id: ADMIN, label: "Plan Admin (Full-Access)", product_role: "full_access" },
  {
    id: LEADER,
    label: "Leadership Team (Full-Access)",
    product_role: "full_access"
  },
  {
    id: MANAGER,
    label: "Management Team (Full-Access)",
    product_role: "full_access"
  },
  { id: MEMBER, label: "Team Member", product_role: "team_member" },
  {
    id: RECOGNITION,
    label: "Recognition Member",
    product_role: "recognition_member"
  }
] as const

export const MAX_FREE_MEMBERS = 3

/******************************/
export const STATEMENT_SECTIONS = {
  BrandPurpose: {
    name: "Brand Purpose",
    plural: "Brand Purposes",
    domId: "brand-purpose"
  },
  BlueSkyVision: {
    name: "Blue Sky Vision",
    plural: "Blue Sky Visions",
    domId: "blue-sky-vision"
  },
  CoreValue: { name: "Value", plural: "Values", domId: "values" },
  Strength: { name: "Strength", plural: "Strengths", domId: "swot-strengths" },
  Weakness: {
    name: "Weakness",
    plural: "Weaknesses",
    domId: "swot-weaknesses"
  },
  Opportunity: {
    name: "Opportunity",
    plural: "Opportunities",
    domId: "swot-opportunities"
  },
  Threat: { name: "Threat", plural: "Threats", domId: "swot-threats" }
} as const

export const notificationMessages = {
  "RecognitionNotifier::Notification": "You received a new recognition",
  "RecognitionCommentNotifier::Notification":
    "There is a new comment on a recognition",
  "RecognitionReactionNotifier::Notification":
    "Someone reacted to your recognition",
  "ForumPostNotifier::Notification": "Someone just made a new Community post",
  "ForumPostCommentNotifier::Notification":
    "Someone commented on your Community post",
  "ForumPostReactionNotifier::Notification":
    "Someone reacted to your Community post",
  "BadgeNotifier::Notification": "You received a new badge!"
}

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
] as const

export const monthsAbbr = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
] as const

export const storeNames = [
  "app",
  "onepageview",
  "meetings",
  "recognitions",
  "community",
  "goals"
] as const

export const appSections = [
  "core",
  "activity",
  "goals",
  "alignment",
  "accomplishments",
  "tasks",
  "statements",
  "users",
  "meetings",
  "courses",
  "recognitions",
  "flywheel",
  "community",
  "university",
  "subscription",
  "notifications"
] as const

export const PERMISSIONS: Record<RoleType, AppSectionType[]> = {
  admin: [
    "core",
    "goals",
    "tasks",
    "statements",
    "users",
    "meetings",
    "courses",
    "recognitions",
    "alignment",
    "flywheel",
    "community",
    "university"
  ],
  leader: [
    "core",
    "goals",
    "tasks",
    "statements",
    "users",
    "meetings",
    "courses",
    "recognitions",
    "alignment",
    "flywheel",
    "community"
  ],
  manager: [
    "core",
    "goals",
    "tasks",
    "statements",
    "users",
    "meetings",
    "courses",
    "recognitions",
    "alignment",
    "flywheel",
    "community"
  ],
  member: [],
  recognition: ["recognitions", "alignment", "community", "university"],
  coach: [
    "core",
    "goals",
    "tasks",
    "statements",
    "courses",
    "recognitions",
    "community",
    "university"
  ],
  community: []
}
